import React from 'react';
import { MenuEditor } from './MenuEditor';
import { restaurantMenuApi } from '../services/resortAdminApi';

// Restaurant menu editor — a thin binding of the shared <MenuEditor/> to the
// restaurant admin API (api.resort_admin_menu).
export const RestaurantMenu: React.FC = () => <MenuEditor menuApi={restaurantMenuApi} />;

export default RestaurantMenu;
